import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-surface-dark text-text-dark">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="font-display text-2xl font-bold mb-4">The Fashion House</h3>
            <p className="text-subtle-dark text-sm leading-relaxed">
              Curating timeless elegance since 2020. Premium fashion for the modern individual.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-subtle-dark hover:text-white transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-subtle-dark hover:text-white transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-subtle-dark hover:text-white transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-3">
              <li><Link to="/shop" className="text-subtle-dark hover:text-white transition-colors text-sm">All Products</Link></li>
              <li><Link to="/shop?category=dresses" className="text-subtle-dark hover:text-white transition-colors text-sm">Dresses</Link></li>
              <li><Link to="/shop?category=blazers" className="text-subtle-dark hover:text-white transition-colors text-sm">Blazers</Link></li>
              <li><Link to="/shop?category=accessories" className="text-subtle-dark hover:text-white transition-colors text-sm">Accessories</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-subtle-dark hover:text-white transition-colors text-sm">About Us</Link></li>
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">Contact</a></li>
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">Careers</a></li>
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">Press</a></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">Help</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">Shipping & Returns</a></li>
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">Size Guide</a></li>
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">FAQ</a></li>
              <li><a href="#" className="text-subtle-dark hover:text-white transition-colors text-sm">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-subtle-dark text-sm">
            © 2025 The Fashion House. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <img src="https://cdn-icons-png.flaticon.com/32/349/349221.png" alt="Visa" className="h-6 opacity-60" />
            <img src="https://cdn-icons-png.flaticon.com/32/349/349228.png" alt="Mastercard" className="h-6 opacity-60" />
            <img src="https://cdn-icons-png.flaticon.com/32/349/349230.png" alt="PayPal" className="h-6 opacity-60" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
